import { useEffect, useRef } from "react";
import { usePushNotifications } from "@/hooks/usePushNotifications";

/**
 * Silent push notification activator.
 * Renders nothing — automatically attempts to subscribe the user once
 * if push is supported and permission has already been granted.
 * No prompts, no UI.
 */
const PushNotificationCard = ({ userId }: { userId: string }) => {
  const { supported, subscribed, loading, subscribe, permission } = usePushNotifications(userId);
  const triedRef = useRef(false);

  useEffect(() => {
    if (!supported || loading || subscribed || triedRef.current) return;
    if (permission !== "granted") return;
    triedRef.current = true;
    subscribe().catch(() => {});
  }, [supported, loading, subscribed, permission, subscribe]);

  return null;
};

export default PushNotificationCard;
